
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1018|1160|6719|6945|756|7874|8614)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
